module.exports = __webpack_public_path__ + "static/media/node.188e1060.jpg";